import React from 'react';
import PropTypes from 'prop-types';
import trackLead from '../../trackLead';

const PricingCardTwo = props => {
  const { title, price, surveys } = props;
  return (
    <div className="w-full lg:w-1/4 sm:mx-4 mb-6 shadow rounded">
      <div className="p-6">
        <h2 className="text-lg text-shop-dark-green text-bold text-center">
          {title}
        </h2>
        <div className="p-4">
          <div className="flex flex-row justify-center content-center">
            <h4 className="font-sans font-bold text-shop-dark-green text-4xl">
              {`$${price}`}{' '}
            </h4>
            <p className="font-sans text-shop-dark-green ml-2 self-center">
              {' '}
              / month
            </p>
          </div>
        </div>
      </div>
      <div className="bg-gray-100 flex flex-1 flex-col">
        <div className="flex flex-row mb-4 justify-center items-end">
          <p className="font-sans text-gray-500-dark text-sm mr-2">up to </p>
          <p
            className="font-sans text-shop-dark-green text-xl font-bold"
            style={{ lineHeight: '1.25rem' }}
          >
            {surveys}
          </p>
          <p className="font-sans text-gray-500-dark text-sm ml-2">surveys</p>
        </div>
      </div>
    </div>
  );
};

PricingCardTwo.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  surveys: PropTypes.string,
};

PricingCardTwo.defaultProps = {
  surveys: null,
};

export default PricingCardTwo;
